
import Setting3 from "../../../assets/filled/Setting3.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Setting3Icon({ className, dataTestid = "Setting3Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Setting3 data-testid={dataTestid} className={classes} {...rest} />
  );
}
